import React from 'react';
import { IonModal, IonButton } from '@ionic/react';
import Spinner from '../../../../components/atoms/spinner';
import './FavoriteLandByParcCodeModal.css';

interface FavoriteLandByParcCodeModalProps {
  isOpen: boolean;
  onClose: () => void;
  isLoading: boolean;
  propertyFavoriteLand: any[];
}

const FavoriteLandByParcCodeModal: React.FC<FavoriteLandByParcCodeModalProps> = ({
  isOpen,
  onClose,
  isLoading,
  propertyFavoriteLand
}) => {
  return (
    <IonModal
      isOpen={isOpen}
      initialBreakpoint={0.7}
      breakpoints={[1, 1, 1, 1]}
      onWillDismiss={onClose}
      trigger="open-custom-dialog"
    >
      <div className="wrapper">
        {isLoading ? <Spinner color={"primary"} size={"large"} /> : null}
        <div className="flex flex-col justify-end items-end p-2">
          <IonButton
            color="danger"
            onClick={onClose}
          >
            {" "}
            اغلاق
          </IonButton>
        </div>
        <div className="w-full flex flex-col justify-start items-center py-4 px-6">
          <div className="w-full flex flex-col justify-start items-center ">
            <div className="grid gap-x-8 gap-y-4 grid-cols-3">
              <div className="w-full flex flex-col justify-center items-end">
                <div className="flex flex-col justify-start items-center p-2 px-4 rounded bg-[#04299A]">
                  <p className="font-bold text-paragraphColor text-xl">
                    قطعة
                  </p>
                  <p className="font-bold text-white text-xl">
                    {propertyFavoriteLand[0]?.land_Numbe}
                  </p>
                </div>
              </div>

              <div className="w-full flex flex-col justify-center items-end">
                <div className="flex flex-col justify-start items-center p-2 px-4 rounded bg-[#04299A]">
                  <p className="font-bold text-paragraphColor text-xl">
                    حي
                  </p>
                  <p className="font-bold text-white text-xl">
                    {propertyFavoriteLand[0]?.neighbourhood_Name
                      .replace("حى", "")
                      .replace("حي", "")}
                  </p>
                </div>
              </div>

              <div className="w-full flex flex-col justify-center items-end">
                <div className="flex flex-col justify-start items-center p-2 px-4 rounded bg-[#04299A]">
                  <p className="font-bold text-paragraphColor text-xl">
                    مدينة{" "}
                  </p>
                  <p className="font-bold text-white text-xl">
                    {propertyFavoriteLand[0]?.city_Name}
                  </p>
                </div>
              </div>
            </div>

            <div className="w-full bg-bkColor rounded border-[1px] border-paragraphColor flex flex-col justify-start items-start py-2 px-2 mt-2">
              <div className="w-full flex flex-row justify-between items-center mt-3">
                <div className="flex flex-col justify-start items-start ">
                  <p className="font-bold text-primaryColor100 text-2xl">
                    عدد طالبي هذا العقار: ( {propertyFavoriteLand.length} )
                  </p>
                </div>
              </div>
              <table className="w-full text-2xl items-center py-2 mt-2">
                <thead>
                  <tr>
                    <th>رقم الجوال</th>
                  </tr>
                </thead>
                <tbody>
                  {propertyFavoriteLand.map((item: any, index: any) => {
                    return (
                      <tr key={index}>
                        <td>
                          <a
                            href={`tel:+966${Number(
                              item.phoneNumber
                            ).toString()}`}
                            style={{ textDecorationLine: "underline" }}
                          >
                            +966{Number(item.phoneNumber).toString()}
                          </a>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </IonModal>
  );
};

export default FavoriteLandByParcCodeModal;
